import React, { useContext, useState } from 'react'
import { Box, Drawer, Switch, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import XRayContext from './XRayContext'
import { withTwoPassRenderer } from '../../hocs/withTwoPassRenderer'

const XRay: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { classes, cx } = useStyles()
  const componentContext = useContext(XRayContext)

  const [xRay, setXRay] = useState(
    componentContext ? componentContext.xRay : false
  )

  const [xRayId, setXRayId] = useState(
    componentContext ? componentContext.id : null
  )

  const xRaySettings = {
    id: xRayId,
    xRay: xRay,
    setXRayId,
    setXRay,
  }
  return (
    <XRayContext.Provider value={xRaySettings}>
      <Box>
        <Drawer
          anchor="bottom"
          classes={{
            paper: cx({
              [classes.drawer]: true,
              [classes.drawerOpen]: xRay,
            }),
          }}
          elevation={8}
          open
          variant="permanent"
        >
          <Typography variant="h4">
            X-RAY <Switch checked={xRay} onChange={() => setXRay(!xRay)} />
          </Typography>
          {xRay && xRayId && (
            <Typography>
              {'Contentful ID: '}
              <a
                className={classes.link}
                href={`https://app.contentful.com/spaces/7thvzrs93dvf/entries/${xRayId}`}
                rel="noreferrer"
                target="_blank"
              >
                {xRayId}
              </a>
            </Typography>
          )}
        </Drawer>
        <Box className={classes.childrenWrapper}>{children}</Box>
      </Box>
    </XRayContext.Provider>
  )
}

const useStyles = makeStyles()({
  childrenWrapper: {
    height: '100%',
    width: '100%',
  },
  drawer: {
    backgroundColor: 'rgba(0,0,0,.7)',
    boxShadow: '0 0 .5em 0 gray',
    color: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '.25em 1em 0',
    width: '9.5em',
  },
  drawerOpen: {
    width: '100%',
  },
  link: {
    color: 'white',
  },
})

export default withTwoPassRenderer(XRay)
